import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Col, Container, Image, Row, Nav, Button } from "react-bootstrap"
import { FaList, FaThLarge } from 'react-icons/fa';

import S from '../lib/Security';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import C from '../lib/Confg'
import MasterConfiguration from './MasterConfiguration';
import N from '../lib/Network';

var Buffer = require('buffer/').Buffer
var CryptoJS = require("crypto-js");

const Dashboard = () => {
    useEffect(() => {
        getKeys(); 
        localStorage.getItem('tenantId');
    }, [])
    function getKeys(){
        if(S.getPrivateKey() == '' && S.getPublicKey() == ''){
          N.getRSAApi('/getRsaKeys')
          .then(res => {
              let resObj = JSON.parse(res.data);
              let resJson = JSON.parse(resObj.responseJson);
              if(resJson.privateKey && resJson.publicKey){
                  let newKey = CryptoJS.enc.Utf8.parse('NexStepPrivacy@#');
                  // Decrypt
                  var privateKeyBytes = CryptoJS.AES.decrypt(resJson.privateKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.privateKey = privateKeyBytes.toString(CryptoJS.enc.Utf8);
      
                  var publicKeyBytes = CryptoJS.AES.decrypt(resJson.publicKey, newKey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
                  S.publicKey = publicKeyBytes.toString(CryptoJS.enc.Utf8);
              }
          })
          .catch(err => {
              console.log("Error : "+err);
          });
        }
      }
    return (
        <div id="content-wrapper" className="d-flex flex-column">
            {<Sidebar />}
            {<Topbar />}
            <div id="wrapper">
                <div id="content">
                    {/* <!-- Begin Page Content --> */}
                    <Container fluid>
                        <Row>
                            <Col xs={12} md={12} lg={12}>
                                <div className="card dash-data-card">
                                    <div className="card-header pl-4 pr-4">
                                        <h5 className="headerTitle float-left mt-1">Products</h5>
                                        <div className="ml-auto float-right">
                                            <Link to="/DashboardVerticalView"  className="btn btn-sm btn-primary shadow-sm">
                                                <FaList className="fas"/>
                                            </Link >
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                        {(localStorage.getItem("isTNERole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/"  id="tne" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img/Exp_0000s_0000_black_Travel.png')} />
                                                    </div>
                                                </div>
                                                <div className="col-md-9 col-lg-9 mb-2 mt-2 pl-0">
                                                    <h5 className="big font-weight-bold text-primary">Travel &amp; Expense Management</h5>
                                                    <div className="project-label text-muted">Enhance employee experience while unearthing savings.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }
                            {(localStorage.getItem("isP2PRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <a href="" onClick={() => N.getCompanyMaster('master/login.tne?command=authenticateUser&encryptedURL=')} id="procureToPay" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img/Exp_0000s_0005_black_budget.png')} />
                                                    </div>
                                                </div>
                                                <div className="col-md-9 col-lg-9 mb-2 mt-2 pl-0">
                                                    <h5 className="big font-weight-bold text-success">Procure To Pay</h5>
                                                    <div className="project-label text-muted">Enhance employee experience while unearthing savings.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </Col>
                            : null }
                            {(localStorage.getItem("isASSETMANAGMENTRole")) ?
                            <Col xs={6} md={4} lg={4}>
                                <Link to="/"  id="asset" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img/Exp_0000s_0001_black_asset-mng.png')} />
                                                    </div>
                                                </div>
                                                <div className="col-md-9 col-lg-9 mb-2 mt-2 pl-0">
                                                    <h5 className="big font-weight-bold text-info">Asset Management</h5>
                                                    <div className="project-label text-muted">Reduce wastage by managing the asset lifecycle.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }
                            {(localStorage.getItem("isRentANDUtilityRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <a href="" onClick={() => N.getCompanyMasterRent('master/login.tne?command=authenticateUser&encryptedURL=')} id="rentUtility" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img/Rent & Utilities.png')} />
                                                    </div>
                                                </div>
                                                <div className="col-md-9 col-lg-9 mb-2 mt-2 pl-0">
                                                    <h5 className="big font-weight-bold text-warning"> Rent Manager</h5>
                                                    <div className="project-label text-muted">Automation &amp; Analytics that help reduce recurring expenses.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </a>
                            </Col>
                            : null}
                            {(localStorage.getItem("isVendorEmpanlementRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/"  id="supplier" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img/Exp_0000s_0003_black_supplier.png')} />
                                                    </div>
                                                </div>
                                                <div className="col-md-9 col-lg-9 mb-2 mt-2 pl-0">
                                                    <h5 className="big font-weight-bold text-secondary">Supplier Portal</h5>
                                                    <div className="project-label text-muted">Process visibility that builds relationship.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }
                            {/*{(localStorage.getItem("isViewTenantUserRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/MasterConfiguration" id="" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                     <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img//web-management.png')} style={{width: '70px'}} />
                                                    </div>
                                                </div>
                                                <div className="mt-auto mb-auto" style={{width: '60%'}}>
                                                    <h5 className="big font-weight-bold text-secondary pt-2">Company Settings</h5>
                                                    <div className="project-label text-muted"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }*/}
                            { (localStorage.getItem("isViewTenantUserRole")) ?
                            <Col xs={6} md={4} lg={4} className="mt-3">
                                <Link to="/NexadminDashboard" id="" className="p-0">
                                    <div className="card shadow-lg border-left list-group-item-action">
                                        <div className="card-body p-0">
                                            <div className="row info">
                                                <div className="col-md-3 col-lg-3 shoeName">
                                                    <div className="sidebar-brand-text text-right mr-4">
                                                        <Image src={require('../img//web-management.png')} style={{width: '70px'}} />
                                                    </div>
                                                </div>
                                                <div className="mt-auto mb-auto" style={{width: '60%'}}>
                                                    <h5 className="big font-weight-bold text-secondary pt-2">NexAdmin</h5>
                                                    <div className="project-label text-muted"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </Col>
                            : null }
                        </Row>
                    </Container>
                    {/* <!-- /.container-fluid --> */}
                </div>
            </div>
        </div>
    )
}
export default Dashboard;